module.exports = __webpack_public_path__ + "img/Verdadero_o_falso.367e8efd.svg";